import { ILocalSortState } from "../store/offer-page.store"

export const createSortObjectForPreOffersPage = (sortState: ILocalSortState) => {
    return {
        action: sortState.action.filter((item) => item.active).map((item) => item.value),
        agriculture: sortState.cultures
          .filter((item) => item.active)
          .map((item) => item.value),
        active: sortState.active.filter((item) => item.active).map((item) => item.value),
        sorting_direction: sortState.order,
        sorting_param: sortState.options.find((item) => item.active)?.val,
      }
}